export const textStyle = { fontWeight: "500", fontSize: "14px" };

export const statusDotStyle = (color: string) => ({
  width: "15px",
  height: "15px",
  backgroundColor: color,
  borderRadius: "50%",
});
